import { NonAppNavWrapper } from '@/components/generic/non-app-nav'
import { PricingStepOne } from '@/components/page-specific/pricing/step-1'
import { PricingStepTwo } from '@/components/page-specific/pricing/step-two/step-2'
import { getStripePrices } from '@/utils/stripe'
import { useUser } from '@clerk/nextjs'
import type { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useEffect, useState } from 'react'

interface Props {
  plans: Awaited<ReturnType<typeof getStripePrices>>
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const plans = await getStripePrices()

  console.log('plans', plans)

  return {
    props: {
      plans,
    } as const,
  }
}

type ServerProps = InferGetStaticPropsType<typeof getStaticProps>

const PricingMainComponent: NextPage<ServerProps> = (props) => {
  const [step, setStep] = useState(1)
  const { user } = useUser()

  useEffect(() => {
    if (user) {
      const hasViewedTrialExplanation = localStorage.getItem('hasViewedTrialExplanation')

      if (!user.publicMetadata.hasSubscribedBefore && !user.publicMetadata.isSubscribed) {
        if (!hasViewedTrialExplanation) {
          setStep(0)
          localStorage.setItem('hasViewedTrialExplanation', 'true')
        }
      }
    }
  }, [user])

  if (!props.plans) {
    return <>No plans</>
  }

  return (
    <>
      <NextSeo
        title="v0 report pricing"
        description="Upload files, customize sections, and harness our advanced web scraping technology for a detailed report."
      />
      <NonAppNavWrapper>
        {step === 1 && <PricingStepTwo plans={props.plans} />}

        {step === 0 && <PricingStepOne setStep={setStep} />}
      </NonAppNavWrapper>
    </>
  )
}

// const PricingMainComponent: NextPage<ServerProps> = (props) => {
//   return <PricingStepTwo plans={props.plans} />;
// };

export default PricingMainComponent
